import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaitaxiservice() {



    const cardData = {

keyword: "Navi Mumbai Taxi Service",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Navi Mumbai Taxi Service for local travel, airport transfers, corporate commuting, family outings, business meetings, and outstation journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, instant booking support, and doorstep pickup and drop across Navi Mumbai, we ensure a safe, comfortable, and hassle-free travel experience for every passenger.",

topPlaces: [
    {
        title: "Pune",
        description:
            "Pune is one of the most popular destinations from Navi Mumbai, known for its IT parks, educational institutions, business centers, and tourist attractions."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a scenic hill station famous for waterfalls, valleys, caves, and monsoon beauty, making it a preferred weekend getaway from Navi Mumbai."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is a major pilgrimage destination dedicated to Sai Baba and remains one of the most frequently booked taxi routes from Navi Mumbai."
    },
    {
        title: "Nashik & Trimbakeshwar",
        description:
            "Nashik is known for vineyards, temples, and Trimbakeshwar Jyotirlinga, making it a popular religious and leisure travel destination."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, lakes, viewpoints, and cool weather throughout the year."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is renowned for Mahalaxmi Temple, cultural heritage, and traditional cuisine, attracting both pilgrims and tourists."
    },
    {
        title: "Ratnagiri",
        description:
            "Ratnagiri is a beautiful Konkan destination known for Ganpatipule Temple, beaches, forts, and scenic coastal landscapes."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is famous for Ajanta Caves, Ellora Caves, Grishneshwar Jyotirlinga, and rich historical heritage."
    },
    {
        title: "Saputara",
        description:
            "Saputara is Gujarat’s only hill station, known for lakes, ropeway rides, viewpoints, and pleasant weather."
    },
    {
        title: "Goa",
        description:
            "Goa is one of India’s most popular holiday destinations, famous for beaches, nightlife, water sports, and coastal tourism."
    }
],



services: [
{
name: "Navi Mumbai Taxi Service",
description: "1Touch Cabs provides Navi Mumbai Taxi Service for local travel, airport transfers, corporate transportation, family outings, sightseeing tours, railway station transfers, and outstation journeys. We offer a fleet of Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and Tempo Traveller vehicles driven by professional chauffeurs. Our service focuses on punctuality, passenger safety, travel comfort, and affordable pricing. Whether you need a taxi for daily commuting, business meetings, family functions, or long-distance travel, we ensure clean vehicles, transparent fares, 24x7 availability, and dependable customer support for a smooth and hassle-free travel experience across Navi Mumbai and surrounding areas."
},
{
name: "Cab Service in Navi Mumbai",
description: "1Touch Cabs offers Cab Service in Navi Mumbai for individuals, families, tourists, and corporate travellers seeking reliable transportation solutions. Our fleet includes Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and Tempo Traveller vehicles suitable for local rides, airport transfers, city tours, and outstation travel. We provide experienced drivers, well-maintained vehicles, flexible booking options, and transparent pricing. With a commitment to safety, comfort, and customer satisfaction, our cab service ensures timely pickups, smooth travel experiences, and round-the-clock support for all types of transportation requirements."
},
{
name: "Taxi Service in Navi Mumbai",
description: "Taxi Service in Navi Mumbai by 1Touch Cabs delivers convenient and professional transportation for local commuters, business travellers, tourists, and families. We provide a wide selection of air-conditioned vehicles driven by trained chauffeurs who prioritize safety and punctuality. Whether you require airport transfers, office transportation, shopping trips, sightseeing tours, or outstation travel, our taxi service offers affordable fares, online booking facilities, reliable customer support, and comfortable journeys. We strive to provide dependable transportation solutions that meet every travel requirement efficiently."
},
{
name: "Navi Mumbai Taxi",
description: "Navi Mumbai Taxi service from 1Touch Cabs offers dependable transportation for short-distance travel, long-distance journeys, airport transfers, and corporate travel requirements. Our professionally maintained fleet and experienced chauffeurs ensure passengers enjoy safe, comfortable, and timely transportation. We provide flexible travel options, competitive pricing, and convenient booking services for individuals and groups. Whether travelling within Navi Mumbai or to destinations across Maharashtra and neighboring states, our taxi service guarantees quality, reliability, and customer satisfaction."
},
{
name: "Taxi in Navi Mumbai",
description: "Taxi in Navi Mumbai service by 1Touch Cabs provides comfortable and affordable transportation for residents, tourists, and business travellers. We offer multiple vehicle categories including Sedan, SUV, Innova, Innova Crysta, Ertiga, and Kia Carens to suit various travel needs and budgets. Our experienced drivers ensure smooth journeys, timely pickups, and safe travel throughout the route. With online booking options, transparent pricing, and 24x7 customer assistance, we make transportation convenient and stress-free for every passenger."
},
{
name: "Navi Mumbai Cab Service",
description: "Navi Mumbai Cab Service from 1Touch Cabs is designed to provide reliable transportation for local travel, airport transfers, outstation trips, corporate travel, and family journeys. Our fleet consists of clean and comfortable vehicles supported by professional chauffeurs dedicated to passenger safety and satisfaction. We offer flexible travel plans, transparent fares, instant booking confirmation, and responsive customer support. Whether you require transportation for personal or business purposes, our cab service delivers comfort, convenience, and reliability."
},
{
name: "Vashi Taxi Service",
description: "Vashi Taxi Service by 1Touch Cabs provides efficient transportation solutions for residents, professionals, tourists, and families travelling within Vashi and beyond. We offer local taxi services, airport transfers, railway station pickups, corporate transportation, and outstation cab facilities using well-maintained vehicles. Our experienced chauffeurs ensure punctual service, comfortable travel, and safe journeys. With affordable pricing, online reservations, and dedicated customer support, we make travel from Vashi convenient and dependable."
},
{
name: "Nerul Taxi Service",
description: "Nerul Taxi Service from 1Touch Cabs offers professional transportation for daily commuting, airport transfers, family travel, sightseeing tours, and outstation journeys. We provide Sedan, SUV, Innova, Innova Crysta, Ertiga, and premium vehicle options driven by experienced chauffeurs. Our focus is on safety, punctuality, comfort, and customer satisfaction. With transparent pricing, convenient booking methods, and 24x7 availability, we deliver reliable travel solutions for passengers travelling from Nerul to various destinations."
},
{
name: "Belapur Taxi Service",
description: "Belapur Taxi Service by 1Touch Cabs provides dependable transportation for corporate executives, local residents, tourists, and families. Our services include local rides, airport transfers, railway station pickups, intercity travel, and outstation cab bookings. We maintain a fleet of comfortable vehicles operated by professional drivers who ensure safe and punctual transportation. With affordable fares, online booking facilities, and customer-focused service, we offer a smooth and enjoyable travel experience from Belapur."
},
{
name: "Kharghar Taxi Service",
description: "Kharghar Taxi Service from 1Touch Cabs offers reliable transportation for business travel, family outings, local commuting, airport transfers, and outstation journeys. Our modern fleet includes Sedan, SUV, Innova, Innova Crysta, Ertiga, and Kia Carens vehicles suitable for different travel requirements. We focus on providing comfortable rides, experienced chauffeurs, transparent pricing, and timely service. Customers benefit from convenient booking options and dependable transportation throughout the day and night."
},
{
name: "Panvel Taxi Service",
description: "Panvel Taxi Service by 1Touch Cabs provides professional transportation solutions for local travel, airport transfers, business meetings, family functions, and outstation tours. Our vehicles are clean, comfortable, and maintained to high standards while being operated by experienced chauffeurs. We ensure timely pickups, safe journeys, transparent pricing, and excellent customer support. Whether travelling within Panvel or to destinations across Maharashtra, our service delivers convenience, reliability, and passenger satisfaction."
},
{
name: "Online Taxi Booking Navi Mumbai",
description: "Online Taxi Booking Navi Mumbai service allows customers to reserve cabs quickly and conveniently through a simple booking process. 1Touch Cabs offers instant confirmations, multiple vehicle choices, affordable pricing, and professional chauffeur support. Whether booking for local travel, airport transfers, business trips, or outstation journeys, passengers receive reliable transportation and dedicated customer assistance. Our online booking platform ensures a seamless reservation experience and dependable travel service."
},
{
name: "Book Taxi Service in Navi Mumbai",
description: "Book Taxi Service in Navi Mumbai with 1Touch Cabs for comfortable and reliable transportation tailored to your travel needs. We provide a wide range of vehicle options, experienced drivers, transparent fares, and flexible travel schedules. From local rides and airport transfers to corporate transportation and outstation trips, our service ensures safety, convenience, and customer satisfaction. Easy booking options and responsive support make travel planning simple and efficient."
},
{
name: "Best Taxi Service in Navi Mumbai",
description: "Best Taxi Service in Navi Mumbai by 1Touch Cabs combines professional chauffeur service, comfortable vehicles, competitive pricing, and dependable transportation solutions. We serve individuals, families, tourists, and corporate clients with a commitment to punctuality, safety, and customer satisfaction. Our fleet includes a variety of vehicle categories suitable for every travel requirement. With 24x7 availability, transparent fares, and excellent support, we deliver a premium travel experience."
},
{
name: "Cheapest Taxi Service in Navi Mumbai",
description: "Cheapest Taxi Service in Navi Mumbai from 1Touch Cabs provides affordable transportation without compromising on quality, safety, or comfort. We offer economical travel solutions for local rides, airport transfers, corporate travel, and outstation journeys using well-maintained vehicles and experienced drivers. Our transparent pricing structure ensures no hidden charges while maintaining excellent service standards. Passengers enjoy reliable transportation at budget-friendly rates backed by professional support."
},
{
name: "24x7 Taxi Service in Navi Mumbai",
description: "24x7 Taxi Service in Navi Mumbai by 1Touch Cabs ensures round-the-clock transportation for airport transfers, emergency travel, business meetings, family functions, and outstation trips. Our fleet remains available day and night with professional chauffeurs ready to provide safe and comfortable rides. We focus on punctuality, customer convenience, and reliable service regardless of travel timing. With instant booking assistance and dedicated support, we are available whenever transportation is required."
},
{
name: "Navi Mumbai Airport Taxi Service",
description: "Navi Mumbai Airport Taxi Service from 1Touch Cabs provides dependable airport transportation for arrivals, departures, business travellers, tourists, and families. We offer timely airport pickups, luggage assistance, flight monitoring, and comfortable vehicles for smooth travel experiences. Our professional chauffeurs ensure safe transportation and punctual service. With transparent pricing, online reservations, and 24x7 availability, we make airport travel convenient, comfortable, and stress-free."
},
{
name: "Airport Taxi Navi Mumbai",
description: "Airport Taxi Navi Mumbai service by 1Touch Cabs offers reliable airport transfer solutions connecting homes, hotels, offices, railway stations, and airports. We provide clean vehicles, trained chauffeurs, and customer-focused service to ensure smooth travel experiences. Whether travelling alone or in a group, passengers enjoy comfortable rides, timely pickups, transparent pricing, and dependable support. Our airport taxi service is designed to maximize convenience and passenger satisfaction."
},
{
name: "Innova Crysta Navi Mumbai Taxi Service",
description: "Innova Crysta Navi Mumbai Taxi Service provides premium transportation for families, corporate travellers, VIP guests, and group travel requirements. 1Touch Cabs offers spacious Innova Crysta vehicles equipped with comfortable seating and modern amenities. Our experienced chauffeurs ensure safe travel, punctual service, and exceptional customer care. Whether for airport transfers, business meetings, sightseeing, or outstation tours, this service delivers luxury, convenience, and reliability."
},
{
name: "Innova Cab Navi Mumbai Taxi Service",
description: "Innova Cab Navi Mumbai Taxi Service offers spacious and comfortable transportation for families, groups, and corporate travellers. 1Touch Cabs provides well-maintained Innova vehicles driven by professional chauffeurs who prioritize safety and passenger comfort. Ideal for airport transfers, local travel, sightseeing tours, and outstation journeys, our Innova cab service combines affordability with convenience. Customers enjoy transparent pricing, reliable service, and flexible travel arrangements."
},
{
name: "Ertiga Cab Navi Mumbai Taxi Service",
description: "Ertiga Cab Navi Mumbai Taxi Service delivers practical and comfortable transportation for families, tourists, and small groups. 1Touch Cabs offers clean Ertiga vehicles with experienced chauffeurs for local rides, airport transfers, business travel, and long-distance journeys. We ensure smooth travel experiences through punctual service, affordable fares, and professional customer support. Our Ertiga cab service is an excellent choice for comfortable and economical transportation."
},
{
name: "Swift Dzire Cab Navi Mumbai Taxi Service",
description: "Swift Dzire Cab Navi Mumbai Taxi Service provides affordable and comfortable Sedan transportation for daily commuting, airport transfers, corporate travel, and outstation trips. 1Touch Cabs offers well-maintained Swift Dzire vehicles driven by courteous and experienced chauffeurs. We focus on punctuality, passenger comfort, and transparent pricing while delivering dependable transportation solutions. Customers benefit from convenient booking options and excellent travel experiences."
},
{
name: "Kia Carens Cab Navi Mumbai Taxi Service",
description: "Kia Carens Cab Navi Mumbai Taxi Service offers stylish and spacious transportation for families, groups, tourists, and business travellers. 1Touch Cabs provides modern Kia Carens vehicles with professional chauffeurs dedicated to safety and customer satisfaction. Whether for local travel, airport transfers, sightseeing, or outstation journeys, passengers enjoy comfortable seating, smooth rides, and reliable service. Our Kia Carens fleet delivers convenience and premium travel comfort."
},
{
name: "Sedan Cab Navi Mumbai Taxi Service",
description: "Sedan Cab Navi Mumbai Taxi Service provides economical and comfortable transportation for individual travellers, couples, and small families. 1Touch Cabs offers air-conditioned Sedan vehicles suitable for local rides, airport transfers, office travel, and outstation trips. Our experienced drivers ensure safe journeys, punctual pickups, and professional service. With transparent pricing, clean vehicles, and flexible booking options, we provide dependable transportation at affordable rates."
},
{
name: "SUV Cab Navi Mumbai Taxi Service",
description: "SUV Cab Navi Mumbai Taxi Service offers spacious and powerful transportation for families, groups, tourists, and corporate travellers. 1Touch Cabs provides well-maintained SUV vehicles ideal for city travel, airport transfers, long-distance journeys, and sightseeing tours. Our professional chauffeurs ensure passenger safety, comfort, and timely service throughout the trip. With competitive pricing, online booking facilities, and dependable support, we deliver a superior travel experience."
}
],

tableData: [
["Navi Mumbai Taxi Service","Cab Service in Navi Mumbai"],
["Taxi Service in Navi Mumbai","Navi Mumbai Taxi"],
["Taxi in Navi Mumbai","Navi Mumbai Cab Service"],
["Vashi Taxi Service","Nerul Taxi Service"],
["Belapur Taxi Service","Kharghar Taxi Service"],
["Panvel Taxi Service","Online Taxi Booking Navi Mumbai"],
["Book Taxi Service in Navi Mumbai","Best Taxi Service in Navi Mumbai"],
["Cheapest Taxi Service in Navi Mumbai","24x7 Taxi Service in Navi Mumbai"],
["Navi Mumbai Airport Taxi Service","Airport Taxi Navi Mumbai"],
["Innova Crysta Navi Mumbai Taxi Service","Innova Cab Navi Mumbai Taxi Service"],
["Ertiga Cab Navi Mumbai Taxi Service","Swift Dzire Cab Navi Mumbai Taxi Service"],
["Kia Carens Cab Navi Mumbai Taxi Service","Sedan Cab Navi Mumbai Taxi Service"],
["SUV Cab Navi Mumbai Taxi Service","Navi Mumbai Taxi Service"]
],











whychoose: [
    {
        WhyChooseheading: "Reliable Navi Mumbai Taxi Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Navi Mumbai Taxi Services for local travel, airport transfers, outstation journeys, corporate transportation, sightseeing tours, and daily commuting needs."
    },
    {
        WhyChooseheading: "24x7 Taxi Availability Across Navi Mumbai",
        WhyChoosedescription: "Our taxi services operate round the clock, allowing customers to book transportation anytime for business meetings, airport travel, family functions, and emergency travel requirements."
    },
    {
        WhyChooseheading: "Local and Outstation Travel Solutions",
        WhyChoosedescription: "Whether you need a taxi within Navi Mumbai or for destinations like Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Surat, Ahmedabad, Goa, and other cities, we provide reliable travel solutions."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "Airport Pickup and Drop Specialists",
        WhyChoosedescription: "We provide smooth airport transfers to and from Mumbai Airport and Navi Mumbai Airport with timely pickups, professional drivers, and comfortable vehicles."
    },
    {
        WhyChooseheading: "Professional Drivers and Safe Travel",
        WhyChoosedescription: "Our experienced chauffeurs ensure safe driving, route expertise, punctual service, and customer satisfaction throughout every journey."
    },
    {
        WhyChooseheading: "Coverage Across All Navi Mumbai Areas",
        WhyChoosedescription: "Taxi services are available in Vashi, Nerul, Belapur, Kharghar, Panvel, Airoli, Ghansoli, Koparkhairane, Sanpada, CBD Belapur, and nearby locations."
    },
    {
        WhyChooseheading: "Ideal for Families, Tourists, and Corporate Clients",
        WhyChoosedescription: "From individual travelers and families to corporate teams and tourist groups, we provide suitable transportation solutions for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "What services are included in Navi Mumbai Taxi Service?",
        answer: "Mumbai Airport Cabs offers local taxi services, airport transfers, outstation travel, corporate transportation, sightseeing tours, employee transport, and customized travel solutions."
    },
    {
        question: "Can I book a taxi for airport transfers?",
        answer: "Yes, airport pickup and drop services are available for Mumbai Airport and Navi Mumbai Airport."
    },
    {
        question: "Which vehicles are available for booking?",
        answer: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles."
    },
    {
        question: "Do you provide outstation taxi services from Navi Mumbai?",
        answer: "Yes, outstation taxi services are available for Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, Surat, Ahmedabad, and many other destinations."
    },
    {
        question: "Can corporate clients use your taxi services regularly?",
        answer: "Yes, we provide transportation solutions for executives, employees, business travelers, and corporate organizations."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family tours, weddings, corporate outings, educational trips, and group transportation."
    },
    {
        question: "Can I schedule a taxi in advance?",
        answer: "Yes, advance booking is recommended to secure your preferred vehicle and ensure smooth travel planning."
    },
    {
        question: "Do you provide Navi Mumbai sightseeing taxi services?",
        answer: "Yes, customers can book taxis for city tours, tourist attractions, shopping trips, and customized sightseeing itineraries."
    },
    {
        question: "Are your drivers experienced and verified?",
        answer: "Yes, all drivers are professionally trained, experienced, and familiar with local as well as outstation travel routes."
    },
    {
        question: "How can I book a Navi Mumbai Taxi Service?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rahul Patankar",
        feedback:
            "I regularly use Mumbai Airport Cabs for local travel and airport transfers in Navi Mumbai. The service is always punctual, the vehicles are clean, and the drivers are professional.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Snehal Shah",
        feedback:
            "We booked a taxi for a family outing and had an excellent experience. The vehicle was comfortable, the driver was courteous, and the entire journey was smooth and enjoyable.",
        rating: 5
    }
];



























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Navi Mumbai Taxi Service",
"image": "https://www.mumbaiairportcabs.com/assets/images/navi-mumbai-taxi-service.jpg",
"description": "Book Navi Mumbai taxi service for local rides, airport transfers, and outstation travel. Mumbai Airport Cabs offers reliable cab service across Vashi, Nerul, Belapur, Kharghar, and Panvel with professional drivers, affordable fares, and 24x7 availability.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/navi-mumbai-taxi-service"
}
};






    return (
        <div>


<Helmet>
  <title>Navi Mumbai Taxi Service | Local Cab Booking | +91 9545731161</title>

<meta
 name="description"
 content="Book Navi Mumbai taxi service for local travel, airport transfers, and outstation trips. Reliable cab service across Vashi, Nerul, Belapur, Kharghar, and Panvel with 24x7 availability."
/>

<meta
 name="keywords"
 content="navi mumbai taxi service, cab service in navi mumbai, taxi service in navi mumbai, navi mumbai taxi, taxi in navi mumbai, navi mumbai cab service, vashi taxi service, nerul taxi service, belapur taxi service, kharghar taxi service, panvel taxi service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/26.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Navimumbaitaxiservice;